import React from 'react'
import { t } from 'ttag'

import { EditButton } from 'components/modules/creators/TemplatesCreator/tabs/Interviews/common/ActionButtons/EditButton/EditButton'
import { DeleteButton } from 'components/modules/creators/TemplatesCreator/tabs/Interviews/common/ActionButtons/DeleteButton/DeleteButton'
import { Box } from 'components/layout/Box/Box'
import { Chip } from 'components/shared/Chip/Chip'

import { categoryNames } from 'components/common/JobProfileWidget/text'

import styles from './Header.module.scss'

export const Header = ({
  categoryName,
  competency,
  edited,
  language,
  scoreable,
  onDeleteCategoryOpen,
  onEditCategoryOpen,
  isCategoryDeletable,
}) => {
  const competencyLabel = competency
    ? categoryNames(language)[competency]?.[0]
    : null

  return (
    <Box
      align="flex-end"
      className={styles.header}
      justify="space-between"
      tagName="header"
    >
      <Box align="flex-start" direction="column">
        <Chip
          color={scoreable ? 'primary' : undefined}
          label={scoreable ? t`Rated` : t`Unrated`}
          size="small"
          variant="filled"
        />
        <h2 className={styles.title}>{categoryName}</h2>
        <Box align="center">
          {competencyLabel ? (
            <p className={styles.subtitle}>
              {t`Based on: “${competencyLabel}“ competency`}
            </p>
          ) : null}
          <Chip
            label={edited === true ? t`Edited` : t`Default`}
            size="small"
            variant="filled"
          />
        </Box>
      </Box>
      <Box align="center" className={styles.actions}>
        <EditButton
          ariaLabel="edit"
          className={styles.button}
          onClick={onEditCategoryOpen}
        />
        <DeleteButton
          ariaLabel="delete"
          className={styles.button}
          onClick={onDeleteCategoryOpen}
          isDisabled={!isCategoryDeletable}
        />
      </Box>
    </Box>
  )
}
